"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineConfiguration = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MachineConfiguration_1 = require("../../sections/machine-configuration/MachineConfiguration");
const react_router_dom_1 = require("react-router-dom");
const MachineConfigContext_1 = require("../../sections/machine-configuration/context/MachineConfigContext");
const MachineConfiguration = ({ title }) => {
    const { id } = (0, react_router_dom_1.useParams)();
    return ((0, jsx_runtime_1.jsx)(MachineConfigContext_1.MachineConfigProvider, { children: (0, jsx_runtime_1.jsx)(MachineConfiguration_1.MachineConfiguration, { title: title, id: id }) }));
};
exports.MachineConfiguration = MachineConfiguration;
